<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-form size="medium" class="log-search" :inline="true" >
          <el-form-item>
            <el-input
              placeholder="请输入操作用户"
              prefix-icon="el-icon-search"
              width="auto"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="请输入操作类型"
              prefix-icon="el-icon-search"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="startTime"
              type="date"
              placeholder="开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="endTime"
              type="date"
              placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-button size="medium" type="primary">查询</el-button>
          <el-button size="medium">导出</el-button>
        </el-form>
      </div>
      <div class="tabel-bar-right">
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span class="el-icon-refresh icon-hover refresh-btn"></span>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="tableData">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="name" label="操作用户"> </el-table-column>
      <el-table-column prop="type" label="操作类型"> </el-table-column>
      <el-table-column prop="msg" label="操作详情"> </el-table-column>
      <el-table-column prop="static" label="操作结果">
        <template slot-scope="scope">
          <template v-if="scope.row.static">
            <el-tag type="success">成功</el-tag>
          </template>
          <template v-else>
            <el-tag type="warning">失败</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="操作时间"> </el-table-column>
    </el-table>
    <el-pagination align="right"
      :current-page="1"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="400"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [{
        id: 1,
        name: 'admin',
        type: '登录',
        msg: 'admin登录成功',
        static: true,
        time: '2016-06-06 16:16:16'
      }, {
        id: 2,
        name: 'admin',
        type: '登录',
        msg: 'admin登录成功',
        static: false,
        time: '2016-06-06 16:16:16'
      }],
      startTime: '',
      endTime: ''
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.log-search .el-form-item {
  margin-bottom: 0;
}
</style>
